import React from 'react';

export default function TestMarker() {
  return (
    <div style={{
      position: 'fixed',
      top: 10,
      right: 10,
      background: '#00ff00',
      color: 'black',
      padding: '10px',
      fontFamily: 'monospace',
      fontSize: '20px',
      fontWeight: 'bold',
      zIndex: 9999
    }}>
      TEST-PASS-{Date.now()}
    </div>
  );
}